// extracted by mini-css-extract-plugin
module.exports = {"main_container":"LoginFooter_main_container__ZZroR","footer_body":"LoginFooter_footer_body__3ICbN","bar":"LoginFooter_bar__47Nd_"};